<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Completed Survey</h4>
                    </div>
                    <div class="card-body">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-md-4 col-sm-6">
                                    <b-form-group label-for="ReferredBy">
                                        <b-form-select
                                            name="ReferredBy"
                                            v-model = "surveyID"
                                            :options="surveys"
                                            class="mb-3"
                                            value-field="item"
                                            text-field="name">
                                        </b-form-select>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <!-- <input name="submit" type="submit" value="Submit" class="btn btn-success btn-xs btn-rounded p-l-10 p-r-10"/>
                                    <input type="hidden" name="pageno" value="#pageno#" id="pageno">
                                    <input type="hidden" id="survey_id"> -->
                                    <b-button  @click="loadItems" class="btn btn-success btn-xs btn-rounded p-l-10 p-r-10">Submit</b-button>
                                </div>
                            </div>
                        </div>
                        <CircleLoader v-if="isLoading" />
                        <vue-good-table
                        mode="remote"
                        :totalRows="totalRecords"
                        :isLoading="isLoading"
                        :pagination-options="{
                            enabled: true,
                            perPage: serverParams.perPage,
                            perPageDropdown: [10, 20, 50, 100, 200],
                        }"
                        :sort-options="{
                            enabled: true,
                            initialSortBy: {
                                field: 'id',
                                type: 'desc',
                            },
                        }"
                        :rows="rows"
                        :columns="columns"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        >
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'action'" class="text-nowrap">
                                    <b-button size="sm"
                                            @click="surveyDetail(props.row.UserID,surveyID,)"
                                            class="mr-1 btn-info text-white">
                                        Detail
                                    </b-button>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
    import Vue from "vue";
    import VueJsonToCsv from 'vue-json-to-csv'
    import SortedTablePlugin from "vue-sorted-table";
    import API from '@/api'
    import moment from 'moment'
import CircleLoader from '@/pages/loaders/CircleLoader.vue'; 

    Vue.component('vue-json-to-csv', VueJsonToCsv)
    Vue.use(SortedTablePlugin, {
        ascIcon: '<i class="ti-arrow-down"></i>',
        descIcon: '<i class="ti-arrow-up"></i>'
    });
    export default {
        name: 'Spotters',
        data() {
            return {
                isDisabled: false,
                selected: true,
                unSelected: false,
                serverParams: {
                    customFilters: {
                        status:'',
                        memberStatus:'',
                        name:''
                    },
                    sort: [
                        {
                            field: 'id', // example: 'name'
                            type: 'desc' // 'asc' or 'desc'
                        }
                    ],

                    page: 1, // what page I want to show
                    perPage: 10 // how many items I'm showing per page
                },
                surveys: [{ item: '', name: 'Select Survey' }],
                columns: [
                    {
                        label: 'Position',
                        field: 'Status',
                        sortable: true,
                    },
                    {
                        label: 'Email',
                        field: "Email",
                        sortable: true,
                    },
                    {
                        label: 'Name',
                        field: "FirstName",
                        sortable: true,
                    },
                    {
                        label: 'Action',
                        field: "action",
                        sortable: false,
                        type: 'percentage',

                    },
                ],
                isLoading: false,
                rows: [],
                totalRecords: 0,
                spots: [],
                surveyID:''
            };
        },
        methods: {
            editMember(member) {
                this.$router.push({name: 'edit_Member', params: {user: member}});
            },
            surveyDetail(userID,surveyID){
                this.$router.push({name: 'survey_details', params: {userID: userID,surveyID:surveyID}});
            //   console.log('userID'+userID);
            //   console.log('surveyID'+surveyID);
            },
            surveyList(){
                API.getSentSurveys(this.serverParams,
                    data => {
                        data.data.forEach((survey) => {
                        this.surveys.push({
                            item: survey.id,
                            name: survey.surveyName,
                            });
                        });
                        console.log(this.rows);
                        this.rows = data.data.data;
                    }, err => {
                })
            },
            loadItems() {
                this.isLoading = true;
                API.membersAttemptSurvey(this.surveyID,
                    data => {
                        this.totalRecords = data.totalRecords;
                        this.rows = data.data;
                        this.rows.forEach(q => {
                            const data = {
                                spot_id: q.user.id,
                            }
                            this.spots.push(data);

                        });
                        this.isLoading = false;
                    }, err => {
                        this.isLoading = false;
                    })
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
            },
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
            },
            changeStatus(spot_id, event) {
                const data = {
                    id: spot_id,
                    status: (event.value === true) ? 'Active' : 'Inactive',
                }
                API.updateMemberStatus(data,
                    data => {
                        if (data.status === 200) {
                            this.$showNotification(data,"success")
                        }
                    }, err => {
                    })
            },
            onSortChange(params) {
            Vue.set(this.serverParams.sort, 0, {
                field: params[0].field,
                type: params[0].type,
            });
            this.loadItems();
        },

        },
        computed: {}
        ,
        mounted() {
            this.surveyList();
        }
    }
</script>
